import { render, staticRenderFns } from "./KitsilanoQueuePage.vue?vue&type=template&id=37b51804"
import script from "./KitsilanoQueuePage.vue?vue&type=script&lang=js"
export * from "./KitsilanoQueuePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports